// 添加球队时，球队选择项
export const squadNameList = [
  '中国国家男子足球队',
  '中国国家女子足球队',
  '中国U-23国家男子足球队',
  '中国U-22国家男子足球队',
  '中国U-21国家男子足球队',
  '中国U-20国家男子足球队',
  '中国U-19国家男子足球队',
  '中国U-18国家男子足球队',
  '中国U-17国家男子足球队',
  '中国U-16国家男子足球队',
  '中国U-15国家男子足球队',
  '中国U-14国家男子足球队',
  '中国U-20国家女子足球队',
  '中国U-19国家女子足球队',
  '中国U-18国家女子足球队',
  '中国U-17国家女子足球队',
  '中国U-16国家女子足球队',
  '中国U-15国家女子足球队',
  '中国U-14国家女子足球队'
]

// 编辑添加路由名单，返回时给tip提示。

export const tipPathArr = [
  '/squad/addSquad'
]

// 球员位置
// export const playerOption = [
//   '守门员',
//   '后卫',
//   '中场',
//   '前锋'
// ]

// 球队简称
export const squadSortName = [
  '男足U-14',
  '男足U-15',
  '男足U-16',
  '男足U-17',
  '男足U-18',
  '男足U-19',
  '男足U-20',
  '男足U-21',
  '男足U-22(国奥队)',
  '男足U-23',
  '男足国家队',
  '女足U-14',
  '女足U-15',
  '女足U-16',
  '女足U-17',
  '女足U-18',
  '女足U-19',
  '女足U-20',
  '女足国家队'
]

// 球队性质
export const squadSexList = [
  {
    key: 'male', value: '男足'
  },
  {
    key: 'female', value: '女足'
  },
  {
    key: 'mixed', value: '男女混合'
  }
]

// 球队性质
export const squadSexList1 = [
  {
    key: 'male', value: '男足'
  },
  {
    key: 'female', value: '女足'
  },
  {
    key: 'mixed', value: '与其他单位球员联合组队'
  }
]
// 教案分类
export const tutorialType = [
  '位置训练',
  '守门员训练',
  '其他',
  '心理素质训练',
  '热身',
  '小场比赛/游戏',
  '身体素质训练',
  '定位球训练',
  '战术训练',
  '技术训练'
]

export const userStatus = [
  {
    status: 'EFFECTIVE',
    name: '正常'
  },
  {
    status: 'DISABLED',
    name: '关闭'
  }
]
export const centerStatusList = [
  {
    status: 'EFFECTIVE',
    name: '有效'
  },
  {
    status: 'DISABLED',
    name: '禁用'
  }
]

export const orgTypeList = [
  {
    status: 'PROVINCE',
    name: '省级'
  },
  {
    status: 'CITY',
    name: '市级'
  }
]
export const shareStatusList = [
  {
    status: 'Club',
    name: '內部公开'
  },
  {
    status: 'Private',
    name: '个人私有'
  },
  // {
  //   status: 'Public',
  //   name: '完全公开'
  // }
]

// 证件类型
export const id_types = [
  {key: "中国居民身份证", value: "IDNUMBER"},
  {key: "外国人永久居留身份证", value: "IDTYPECODEWGJZZ"},
  {key: "港澳台居民居住证", value: "IDTYPECODEHMT"},
  {key: "港澳居民来往内地通行证", value: "HM"},
  {key: "台湾居民来往大陆通行证", value: "TAI"},
  {key: "护照（仅国外教练员使用）", value: "PASSPORT"}
]
// 教练等级
export const coachingLevel = [
  { key: 'B级', value:'B' },
  { key: 'A级', value:'A' },
  { key: '职业级', value:'职业' }
]
export const educationList = [
  { key: '小学', value: '小学' },
  { key: '初中', value: '初中' },
  { key: '高中', value: '高中' },
  { key: '职专', value: '职专' },
  { key: '大专', value: '大专' },
  { key: '本科', value: '本科' },
  { key: '硕士', value: '硕士' },
  { key: '博士', value: '博士' },
]

export const genderList = [
  { key: '男', value: '男'},
  { key: '女', value: '女'},
]
// 学校等级
export const schoolLevelList = [
  {
    key: '幼儿园', value: '幼儿园'
  },
  {
    key: '小学', value: '小学'
  },
  {
    key: '初中', value: '初中'
  },
  {
    key: '高中', value: '高中（含中专、职高、技校）'
  }
]
// 球场类型
export const footballType = [
  {
    key: '十一人制', value: '十一人制'
  },
  {
    key: '八人制', value: '八人制'
  },
  {
    key: '五人制', value: '五人制'
  }
]
// 球场类型
export const propertyTypeList = [
  {
    key: '自有', value: '自有'
  },
  {
    key: '租赁', value: '租赁'
  },
  {
    key: '其他', value: '其他'
  }
]

// 比赛名称列表
export const matchNameList = [
  "上海市青少年足球锦标赛暨上海市青少年体育精英系列赛足球比赛",
  "上海市青少年足球联赛（原上海市青少年足球俱乐部联赛）",
  "全运会",
  "三大球运动会",
  "学青会",
  "中国足协青少年足球锦标赛",
  "中国青少年足球联赛",
  "中国足协全国青少年女子足球锦标赛",
  "全国体校杯",
  "全国青少年校园足球联赛",
  "集训营训练赛",
  "其他"
]
//精英集训队/训练营/参赛队
export const trainCampTypeList = [
  { label: '训练营', value: 'bootcamp', },
  { label: '集训队', value: 'trainTeam', },
  { label: '参赛队', value: 'matchTeam', },
  { label: '其他', value: 'other', },
]
